import PropTypes from 'prop-types';
import React from 'react';
import styled from "styled-components";
import {White} from "@/styles/globalStyleVars";


const IconText = ({title, shortDesc, imageSrc}) => {
    return (
        <StyledIconText>
            <img height={40} width={40} src={imageSrc ? imageSrc : '/images/dynamic/trust.svg'} alt="icon"/>
            <div className="wrap">
                <h5>{title ? title : ''}</h5>
                <p>{shortDesc ? shortDesc : ''}</p>
            </div>
        </StyledIconText>
    );
};

export const StyledIconText = styled.div`

    display: flex;
    gap: 0 60px;
    align-items: flex-start;
    
    .wrap {
        max-width: calc(100% - 60px);

        h5 {
            font-size: 22px;
            line-height: 24px;
            font-weight: 500;
            color: ${White};
            margin-bottom: 20px;
        }
    }
`;
IconText.propTypes = {
    shortDesc: PropTypes.string.isRequired, // The currently active slide index
    title: PropTypes.string.isRequired, // The title of this slide, which may contain HTML
    imageSrc: PropTypes.string.isRequired, // The title of this slide, which may contain HTML

};


export {IconText};
